import React, { FunctionComponent, useState } from 'react'
import Calendar from 'react-calendar'
import * as S from './styled'
import './DatePicker.css'
import './Calendar.css'
import { useDispatch, useSelector } from 'react-redux'
import { MainState } from '../../../redux/reducers'
import moment from 'moment'
import { requestActions } from '../../../redux/requests'

type OwnProps = {
  showCalender: boolean
  setShowCalender: React.Dispatch<React.SetStateAction<boolean>>
  setStartDate: React.Dispatch<React.SetStateAction<Date>>
  setEndDate: React.Dispatch<React.SetStateAction<Date>>
  startDate: Date
  endDate: Date
  startDateLocal: Date
  setStartDateLocal: React.Dispatch<React.SetStateAction<Date>>
  endDateLocal: Date
  setEndDateLocal: React.Dispatch<React.SetStateAction<Date>>
  dateCaption?: string
  setWeeks: React.Dispatch<React.SetStateAction<number>>
}

type Props = OwnProps

export const DatepickerBox: FunctionComponent<Props> = ({
  setShowCalender,
  startDateLocal,
  endDateLocal,
  setStartDateLocal,
  setEndDateLocal,
  setEndDate,
  setStartDate,
}) => {
  const dispatch = useDispatch()
  const uid = useSelector((state: MainState) => state.misc.uid)
  const [caption, setCaption] = useState<string>()
  function handleClick() {
    dispatch(
      requestActions.products.setCustomFilter(
        uid!,
        moment(startDateLocal).format('YYYY-MM-DD'),
        moment(endDateLocal).format('YYYY-MM-DD'),
        dispatch,
        caption ??
          `${moment(startDateLocal).format('YYYY-MM-DD')} - ${moment(endDateLocal).format(
            'YYYY-MM-DD',
          )}`,
      ),
    )
    setStartDate(startDateLocal)
    setEndDate(endDateLocal)
    setShowCalender(false)
  }
  return (
    <S.Container>
      <S.DivStyled>
        <S.CloseCalendar onClick={() => setShowCalender(false)}> X </S.CloseCalendar>
      </S.DivStyled>
      <S.CalendarContainer>
        <S.FirstCalendarContainer>
          <S.CaptionCalendar>Start Date</S.CaptionCalendar>
          <Calendar
            className={'startDate'}
            showWeekNumbers={true}
            selectRange={false}
            maxDate={new Date()}
            locale={'sv-SV'}
            closeCalendar={false}
            returnValue={'start'}
            onChange={setStartDateLocal}
            value={[startDateLocal, endDateLocal]}
          />
        </S.FirstCalendarContainer>
        <S.SecondCalendarContainer>
          <S.CaptionCalendar>End Date</S.CaptionCalendar>
          <Calendar
            showWeekNumbers={true}
            selectRange={false}
            locale={'sv-SV'}
            closeCalendar={false}
            returnValue={'start'}
            onChange={setEndDateLocal}
            defaultActiveStartDate={endDateLocal}
            value={[startDateLocal, endDateLocal]}
          />
        </S.SecondCalendarContainer>
      </S.CalendarContainer>
      <S.InputBar>
        <label htmlFor="caption">Namnge filter:</label>
        <S.Input
          type={'text'}
          name={'caption'}
          onChange={event => setCaption(event.target.value)}
          onKeyUp={e => (e.key === 'Enter' ? handleClick() : '')}
        />

        <S.SelectCalendar onClick={handleClick}> ✓ Använd</S.SelectCalendar>
      </S.InputBar>
    </S.Container>
  )
}

export default DatepickerBox
